import { createBrowserHistory } from 'history'

// Type definition for query string map
type QueryStringMap = { [key: string]: string }

// Create browser history with a base path
const history = createBrowserHistory({
  basename: process.env.REACT_APP_BASE_PATH || '', // Provide a fallback
})

// Function to parse query strings
function qs(queryString: string, parameter: string): string {
  const strToMap: QueryStringMap = queryString
    .slice(1) // Remove "?"
    .split('&') // Split by "&"
    .reduce<QueryStringMap>((acc, item) => {
      const [name, ...value] = item.split('=')
      return {
        ...acc,
        [name]: value.join('='), // Join the rest of the values
      }
    }, {})

  return strToMap[parameter] !== undefined ? strToMap[parameter] : ''
}

export { history, qs }
